export const getSelectedOrdersIds = (state) =>
  Object.keys(state.orderList.selectedOrders)
export const isOrderSelected = (state) => (orderId) =>
  orderId in state.orderList.selectedOrders
export const allOrdersAreSelected = (state) => (orderIds) =>
  orderIds.length > 0 &&
  orderIds.every((orderId) => orderId in state.orderList.selectedOrders)
export const filterSelectedOrders = (state) => (orders) =>
  orders.filter((order) => state.orderList.selectedOrders[order.id])
export const isMergeOrderModalOpen = (state) =>
  state.orderList.mergeOrdersModalOpen
export const mergeOrderMessages = (state) => state.orderList.mergeOrderMessages
export const shouldCheckMergeOrders = (state) =>
  state.orderList.shouldCheckMergeOrders
export const shouldDisplayDivisionColumn = (state) =>
  state.orderList.shouldDisplayDivisionColumn
